module.exports = __webpack_public_path__ + "static/img/statusCorrectStaticPoppy.ba09ec49.png";